import { Link, Route, Routes } from 'react-router-dom';
import { SignedInAs } from '../components/SignedInAs.js';
import { RosterPage } from '../admin/RosterPage.js';
import { SurveyDataPage } from '../admin/SurveyDataPage.js';
import { SurveyEditorPage } from '../admin/SurveyEditorPage.js';
import { SurveyListPage } from '../admin/SurveyListPage.js';

/** Consultancy portal: surveys, the editor and roster management. */
export function AdminPage() {
  return (
    <main className="wide">
      <header className="admin-header">
        <h1>
          <Link to="/admin">Voice to Value · Admin</Link>
        </h1>
        <SignedInAs />
      </header>

      <Routes>
        <Route index element={<SurveyListPage />} />
        <Route path="surveys/new" element={<SurveyEditorPage />} />
        <Route path="surveys/:surveyId" element={<SurveyEditorPage />} />
        <Route path="surveys/:surveyId/data" element={<SurveyDataPage />} />
        <Route path="vendors/:vendorId/roster" element={<RosterPage />} />
      </Routes>
    </main>
  );
}
